import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePutMyFranchise = (nameRef, contactRef, addressRef, storeTicketNameRef, logoImgState) => {
    const navigate = useNavigate()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const request = () => {
        fetchRequest("PUT", `/admin/franchise/my`, {
            "name": nameRef?.current?.value,
            "contact": contactRef?.current?.value,
            "address": addressRef?.current?.value,
            "store_ticket_name": storeTicketNameRef?.current?.value,
            "logo_img": logoImgState
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                navigate("/manager/my")
                break
            case 400:
                if (fetchResult?.data?.error_code === "name") setAlert("프렌차이즈 이름을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "contact") setAlert("대표 연락처를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "address") setAlert("대표 주소를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "store_ticket_name") setAlert("매장 이용권 이름을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "logo_img") setAlert("로고 이미지를 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
        }
    }, [fetchResult])

    return [request]
}

export default usePutMyFranchise